import type { SearchData, ValuationType } from './SearchElements';
import type { DimensionUnitType, DimensionDisplayType } from './UserProfile';

export type ArtworkReportType = "Catalogue" | "Detail" | "Summary" | "Insurance";
export type ArtworkReportGroupBy = "None" | "Category" | "Artist" | "Location";
export type ArtworkReportSortBy =
    | "Reference"
    | "Artist"
    | "Title"
    | "Year"
    | "Category"
    | "Location"
    | "Value";

export type ArtworkReportFormat = "Pdf" | "Excel";
export type ReportValuationFormat = "compact" | "standard";
export interface ArtworkReportRequest extends SearchData {

    artworkIds?: number[];

    description?: string;
    artistIds?: number[];
    categoryIds?: number[];
    locations?: number[];

    minValue?: number | null;
    maxValue?: number | null;
    currency?: string;

    acquiredFrom?: string | null;
    acquiredTo?: string | null;

    title?: string;

    reportFormat?: ArtworkReportFormat;
    reportType?: ArtworkReportType;
    groupBy?: ArtworkReportGroupBy;
    subGroupBy?: ArtworkReportGroupBy;
    sortBy?: ArtworkReportSortBy;
    reportValuationType: ValuationType;
    reportValuationFormat: ReportValuationFormat;

    includeCoverPage?: boolean;
    includeIndexPage?: boolean;
    groupIndexPage?: boolean;
    includeImages?: boolean;
    includeReference?: boolean;
    includeDimensions?: boolean;
    includeWeight?: boolean;
    includeLocation?: boolean;
    includeValuation?: boolean;
    includeProvenance?: boolean;
    includeMedium?: boolean;

    dimensionUnits: DimensionUnitType;
    dimensionDetails: DimensionDisplayType;

    reportVersion?: number;
    reportCurrency: string;
}

export interface ReportSelectionRequest {
    title?: string;
    reportFormat: ArtworkReportFormat;
    reportType: ArtworkReportType;
    groupBy: ArtworkReportGroupBy;
    subGroupBy: ArtworkReportGroupBy;
    sortBy: ArtworkReportSortBy;
    reportValuationType: ValuationType;
    reportValuationFormat: ReportValuationFormat;
    includeCoverPage: boolean;
    includeIndexPage: boolean;
    groupIndexPage: boolean;
    includeImages: boolean;
    includeDimensions: boolean;
    includeWeight: boolean;
    includeLocation: boolean;
    includeValuation: boolean;
    includeReference: boolean;
    includeProvenance: boolean;
    includeMedium: boolean;
    dimensionUnits: DimensionUnitType;
    dimensionDetails: DimensionDisplayType;
}

export function buildArtworkReportRequest(
    search: SearchData,
    options: ReportSelectionRequest,
    standardCurrency: string,
    artworkIds?: number[],
): ArtworkReportRequest {
    return {
        ...search,
        artworkIds,

        title: options.title?.trim() || "Artwork Report",

        reportFormat: options.reportFormat,
        reportType: options.reportType,
        groupBy: options.groupBy,
        subGroupBy: options.subGroupBy,
        sortBy: options.sortBy,
        reportValuationType: options.reportValuationType,
        reportValuationFormat: options.reportValuationFormat,

        includeCoverPage: options.includeCoverPage,
        includeIndexPage: options.includeIndexPage,
        groupIndexPage: options.groupIndexPage,
        includeImages: options.includeImages,
        includeReference: options.includeReference,
        includeDimensions: options.includeDimensions,
        includeWeight: options.includeWeight,
        includeLocation: options.includeLocation,
        includeValuation: options.includeValuation,
        includeMedium: options.includeMedium,
        includeProvenance: options.includeProvenance,

        reportCurrency: standardCurrency,

        dimensionUnits: options.dimensionUnits,
        dimensionDetails: options.dimensionDetails,
        
    };
}